import axios from "axios";

export default {
  async get() {
    return await axios
      .get("irmc/getQuestions")
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.response.data.message);
      });
  },
  async saveData(req) {
    axios
      .post("irmc", req)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.response.data.message);
      });
  },

  async getIrmcByDispatch(id) {
    return axios
      .get("irmc/irmc-by-dispatch/" + id)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw new Error(err.response.data.message);
      });
  },
};
